import { render } from "./Thoughts.vue?vue&type=template&id=9b86e352&ts=true"
import script from "./Thoughts.vue?vue&type=script&lang=ts"
export * from "./Thoughts.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__